import React, { useState } from 'react';
import { 
  FaDownload, 
  FaCopy, 
  FaCheck, 
  FaFileWord,
  FaClipboard,
  FaCheckCircle,
  FaArrowRight,
  FaRobot, 
  FaMagic
} from 'react-icons/fa';
import Card from '../../../components/Card/Card';
import Button from '../../../components/buttons/Button';
import './steps.css';
import { createLogger } from '../../../services/Debug';
function StepExport({ templateConfig, onExport, isLoading, sections, onShowCustomInstructions }) {
  const log = createLogger('StepExport');
  const [exportSuccess, setExportSuccess] = useState(null);
  const [copiedSyntax, setCopiedSyntax] = useState(false);

  // Handle download
  const handleDownload = async () => {
    setExportSuccess(null);
    const success = await onExport('download');
    if (success) {
      setExportSuccess('download');
      setTimeout(() => setExportSuccess(null), 3000);
    }
  };


  // Copy template syntax to clipboard
  const handleCopySyntax = async () => {
    try {
      // Generate basic syntax for clipboard
      const syntax = generateBasicSyntax(templateConfig);
      await navigator.clipboard.writeText(syntax);
      setCopiedSyntax(true);
      setTimeout(() => setCopiedSyntax(false), 2000);
    } catch (error) {
      log.error('Failed to copy:', error);
    }
  };

  // Generate basic syntax
  const generateBasicSyntax = (config) => {
    let syntax = `Template: ${config.name || 'Sans titre'}\n`;
    syntax += `Type: ${config.reportType || 'Standard'}\n`;
    syntax += `Logo: ${config.includeLogo ? 'Oui' : 'Non'}\n`;
    syntax += `Mise en page: ${config.pageLayout || 'Standard'}\n\n`;
    syntax += `Instructions:\n`;
    syntax += `1. Téléchargez le fichier .docx\n`;
    syntax += `2. Ouvrez-le dans Microsoft Word\n`;
    syntax += `3. Personnalisez les styles selon vos besoins\n`;
    syntax += `4. Sauvegardez et utilisez comme template\n`;
    return syntax;
  };

  return (
    <div className="step-export">
      {/* Success Message */}
      {exportSuccess && (
        <div className="step-export-success">
          <FaCheck /> 
          {exportSuccess === 'download' 
            ? 'Template téléchargé avec succès!' 
            : 'Template sauvegardé avec succès!'}
        </div>
      )}

      {/* Next Steps - More Prominent */}
      <Card className="step-export-next-prominent">
        <h3><FaCheckCircle /> Prochaines étapes</h3>
        <ol className="export-next-list-prominent">
          <li><FaArrowRight /> Téléchargez votre template</li>
          <li><FaArrowRight /> Ouvrez le fichier dans Microsoft Word</li>
          <li><FaArrowRight /> Personnalisez les styles et la mise en page selon vos besoins</li>
          <li><FaArrowRight /> Uploadez ensuite ce template pour la génération de rapports </li>
        </ol>
      </Card>

      {/* Export Options - Simplified */}
      <div className="step-export-options">
        {/* Download Option */}
        <Card className="export-option-card">
          <div className="export-option-icon word">
            <FaFileWord size={48} />
          </div>
          <h3>Télécharger le template</h3>
          <p>Téléchargez le fichier .docx, adaptez son design et uploadez le ensuite comme template.</p>
          <Button
            variant="word"
            icon={FaDownload}
            onClick={handleDownload}
            disabled={isLoading}
            
          >
            {isLoading ? 'Génération...' : 'Télécharger (.docx)'}
          </Button>
        </Card>



        {/* Custom Instructions Option */}
        <Card className="export-option-card">
          <div className="export-option-icon">
            <FaMagic size={48} />
          </div>
          <h3>Instructions personnalisées</h3>
          <p>Donner la structure du template aux instructions personnalisées pour ce modèle de rapport.</p>
          <Button
            variant="primary"
            
            icon={FaMagic}
            onClick={onShowCustomInstructions}
            disabled={isLoading}
          >
            Ajouter aux instructions
          </Button>
        </Card>
      </div>

    </div>
  );
}

export default StepExport;